import * as React from 'react';

import styled from 'styled-components';

import { ISanityBlockContent } from '@rbi-ctg/menu';
import ActionButton, { ActionButtonVariants } from 'components/action-button';
import AccountLayout from 'components/layout/account';
import SanityBlockRenderer from 'components/sanity-block-renderer';

const ButtonContainer = styled.div`
  margin: 32px auto 0;
  width: 90%;

  ${Styles.desktop`
    width: 80%;
  `}

  & > :last-child {
    margin-top: 32px;
  }
`;

const Error = styled.p<{ visibility: string }>`
  font-size: 1.25rem;
  color: ${Styles.color.error};
  text-align: center;

  visibility: ${p => p.visibility};
`;

export interface IPageContentProps {
  headerText?: string | null;
  content?: ISanityBlockContent[] | null;
  accountDeleteButtonText?: string | null;
  cancelButtonText?: string | null;
  onAccountDelete(): void;
  onCancel(): void;
  isLoading: boolean;
  isRejected: boolean;
  errorText?: string | null;
}

export const PageContent: React.FC<IPageContentProps> = ({
  headerText,
  content,
  accountDeleteButtonText,
  cancelButtonText,
  onAccountDelete,
  onCancel,
  isLoading,
  isRejected,
  errorText
}) => {
  return (
    <AccountLayout header={headerText}>
      <SanityBlockRenderer content={content} />
      <ButtonContainer>
        <ActionButton fullWidth variant={ActionButtonVariants.OUTLINE} onClick={onCancel}>
          {cancelButtonText}
        </ActionButton>
        <ActionButton
          variant={ActionButtonVariants.OUTLINE}
          onClick={onAccountDelete}
          isLoading={isLoading}
          loadingColor={Styles.color.error}
          fullWidth
        >
          {accountDeleteButtonText}
        </ActionButton>
      </ButtonContainer>
      <Error visibility={isRejected ? 'visible' : 'hidden'}>{errorText}</Error>
    </AccountLayout>
  );
};
